import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { ModifierCodeService } from 'src/app/services/core/modifier-code/modifier-code.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
@UntilDestroy()
@Component({
  selector: 'app-modifier-codes-list',
  templateUrl: './modifier-codes-list.component.html',
  styleUrls: ['./modifier-codes-list.component.css']
})
export class ModifierCodesListComponent implements OnInit {
  modifierCodeList: any;
  selectedStatus = '';
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  search: any;
  status = true
  numberOfRecords = NUMBER_OF_RECORDS
  userPermission = UserPermission;
  modifierCodeModalObj: any;

  constructor(
    private primaryDiagnosisService: ModifierCodeService,
    public permissionService: PermissionService
  ) { }

  ngOnInit() {
    this.getModifierCodes(this.currentPage)
  }

  getModifierCodes(page: number) {
    const queryparams = {
      limit: 50,
      page,
      isActive: this.status
    }
    this.primaryDiagnosisService.get(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results) {
          this.modifierCodeList = data.results;
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getModifierCodes(page);
  }

  onSelectStatus(event: any): void {
    this.status = event.target.value === 'true';
    this.getModifierCodes(this.currentPage = 1)
  }

  openModal(los: any) {
    this.modifierCodeModalObj = los;
  }

  onSave(evt: any) {
    if (evt) {
      const idx = this.modifierCodeList.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.modifierCodeList[idx] = evt;
      } else {
        this.modifierCodeList.splice(idx, 1);
      }
    }
    this.modifierCodeModalObj = null;
  }

  onCloseModal() {
    this.modifierCodeModalObj = null;
  }
}
